import { Decoration } from '@tiptap/pm/view';

import type { RicosServices } from './../../../ricos-types';

import { CATEGORY, LOCATION, SOURCE } from '../../consts';
import { TABLE_TYPE } from '../../types';
import { TableQuery } from '../TableQuery';
import styles from './addRowCol-scss';
import { addSvg } from './svgs';

export const addRowDecoration = (state: $TSFixMe, editor: $TSFixMe, services: RicosServices) => {
  const table = TableQuery.of(state.selection);
  const rowNum = table.getHeight();
  const addRowDiv = document.createElement('div');

  addRowDiv.dataset.hook = 'addRow';
  addRowDiv.innerHTML = addSvg;
  addRowDiv.classList.add(styles.tableAddRow);
  addRowDiv.addEventListener('mousedown', e => {
    e.stopPropagation();
    e.preventDefault();
    editor.chain().addRowAtIndex(rowNum).selectRowAtIndex(rowNum).run();
    services.pluginsEvents.publishTableAddRowCol({
      pluginId: TABLE_TYPE,
      nodeId: table.getNode().attrs.id,
      category: CATEGORY.ROW,
      location: LOCATION.BELOW,
      source: SOURCE.PLUS_BUTTON,
    });
  });

  const rowDecoration = Decoration.widget(table.getStartPos(), addRowDiv);

  return rowDecoration;
};
